export default {
  main: {
    sessionData: null,
    languages: null,
    countries: null,
    municipalities: null,
    offices: null,
    users: null,
    comunities: null,
    provinces: null,
    consultTypes: null,
    defaultLimit: 15,
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/initialState.js